import axios from "axios";
import { jwtDecode } from "jwt-decode";
import md5 from "md5";
import { Navigate } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

const hash = (str: any) => {
  const pass = `${str}${process.env.REACT_APP_HASH_SECRET}`;
  return md5(pass);
};

// handleLogOut
const handleLogout = (e: any) => {
  e.preventDefault();

  localStorage.clear();
  return <Navigate to="/login" replace />;
};

// SIGNIN USER WITH JWT
const JwtReValidate = async () => {
  const token = localStorage.getItem("accessTokens");
  if (!token) return null;
  try {
    const decoded = jwtDecode<any>(token as string);
    if (decoded) {
      const aamarId = decoded.aamarId;
      const id = decoded.id || decoded._id;
      if (!aamarId || !id) return null;
      const newToken = await axios.get(
        `${BASE_URL}aamarDokan/jwt-revalidate/${aamarId}/${id}`
      );
      if (newToken?.data?.access_token) {
        localStorage.setItem("accessTokens", newToken.data.access_token);
        return newToken.data.access_token;
      }
    }
    return null;
  } catch (error) {
    console.error("Invalid token", error);
    return null;
  }
};

export interface WarehousePayload {
  _id?: string;
  id?: string;
  name?: string;
  [key: string]: any;
}

export interface CustomJwtPayload {
  id?: string;
  _id?: string;
  name?: string;
  username?: string;
  email?: string;
  type: string;
  photo?: string | null;
  warehouse?: WarehousePayload | string;
  aamarId?: string;
  package?: any;
  storeSettings?: { posScreen?: string } | any;
  status?: string;
  phone?: string;
  [key: string]: any;
}

let lastRevalidationTime = 0;
const AUTO_REVALIDATE_INTERVAL = 60 * 1000; // 1 minute

const checkAndRevalidateJwt = () => {
  const now = Date.now();
  if (now - lastRevalidationTime > AUTO_REVALIDATE_INTERVAL) {
    lastRevalidationTime = now;
    JwtReValidate().catch((err) => {
      // Silent background refresh
    });
  }
};

const signInUser = (): CustomJwtPayload | null => {
  // const navigate = useNavigate();
  const token = localStorage.getItem("accessTokens");
  if (!token) {
    console.warn("No access token found");
    // navigate("/login", { replace: true });
    return null;
  }

  try {
    const decoded = jwtDecode<CustomJwtPayload>(token);
    // Background revalidation to reflect package/plan updates
    checkAndRevalidateJwt();
    // console.log("Decoded Token:", decoded.type);
    return decoded || null; // Explicitly return null if decoding doesn't yield a value
  } catch (error) {
    console.error("Invalid token", error);
    return null;
  }
};

export { handleLogout, hash, signInUser, JwtReValidate };

